import React from 'react';
import { CLUB } from '../../utils/constants';

/**
 * Verweis auf den Instagram-Kanal.
 *
 * Bewusst nur ein Link und KEIN eingebetteter Feed: Ein Instagram-Embed lädt
 * Skripte und setzt Cookies von Meta, sobald die Seite geöffnet wird - das
 * braeuchte ein Consent-Banner und eine erweiterte Datenschutzerklärung.
 * Ein Link kostet nichts davon.
 */
export default function Instagram() {
  return (
    <section className="mt-section mt-section--alt mt-section--tight" id="instagram">
      <div className="mt-container">
        <div className="mt-ig">
          <span className="mt-kicker">Wir sind auch auf Instagram</span>
          <h2>Da passiert am meisten</h2>
          <p>
            Fotos von Ausfahrten, spontane Treffen und alle Infos zu kommenden Terminen
            findest du zuerst dort.
          </p>

          <a
            className="mt-ig__handle"
            href={CLUB.instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            {CLUB.instagramHandle}
          </a>

          <div className="mt-row" style={{ justifyContent: 'center' }}>
            <a
              className="mt-btn mt-btn--secondary"
              href={CLUB.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              Auf Instagram folgen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
